import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DataLoader from "../../../../Utils/DataLoader";
import { class_all, class_destroy, student_destroy } from "../../../api/Class";
import { impersonate_student } from "../../../../apis/studentManagement/StudentManagement";
import CustomTableWithChild from "../../../../componrnt/pages/CustomTableWithChild";
import { getUserPermission } from "../../../../Utils/Utils";
import { ActiveEvaluation } from "./ActiveEvaluation";
import { STUDENT_PORTAL_URL } from "../../../../constants/Matcher";
import { courseAllowed, getBranchLevel } from "../../../utils/branchLevel";
import DuplicateClasses from "./DuplicateClasses";

const AllClasses = () => {
  const [data, setData] = useState([]);
  const [rawClasses, setRawClasses] = useState([]);
  const [showDuplicate, setShowDuplicate] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [status, setStatus] = useState("1");
  const [getData, setGetData] = useState(false);
  const [showPast, setShowPast] = useState(false);
  const [id, setId] = useState({ class_id: "", branch_id: "" });

  const branchid = localStorage.getItem("b_id");
  const classPermission = getUserPermission("ClassManagement");
  const level = getBranchLevel();
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    async function get_data() {
      const result = await class_all(status, branchid);
      // Filter by branch school level (high vs primary) and hide past
      // years by default. The grade_name field is the year number string
      // (e.g. "7"), which is what courseAllowed expects.
      const filtered = (result?.data || []).filter((elem) => {
        if (!courseAllowed(elem.grade_name, elem.high_school)) return false;
        if (!showPast && elem.year && Number(elem.year) < currentYear) return false;
        return true;
      });
      const arrayData = filtered.map((elem, index) => {
        const {
          id, class_name, year, branch_name, grade_name,
          delete_status, grade_id, term_id, term_name, class_timing, students, branch_id, course_id,
        } = elem;
        return {
          no: `#${index + 1}`,
          name: class_name,
          year: year,
          branch_name: branch_name,
          grade_name: `year ${grade_name}`,
          term_name: term_name || "",
          class_timing: class_timing || "",
          terms: students,
          status_data: delete_status,
          status: delete_status == 0 ? "Inactive" : "Active",
          action: (
            <div data-tag="allowRowEvents" style={{ display: "flex", gap: 6, alignItems: "center" }}>
              {classPermission?.add === 1 && (
                <Link
                  to={`/branch/class-management/assigne-student/${grade_id}/${term_id}/${id}/${course_id}`}
                  style={s.actionBtn}
                  title="Assign Student"
                >
                  <i className="fa fa-user-plus"></i>
                </Link>
              )}
              {classPermission?.edit === 1 && (
                <Link
                  to={`/branch/class-management/edit/${id}`}
                  style={s.actionBtn}
                  title="Edit"
                >
                  <i className="fa fa-pencil"></i>
                </Link>
              )}
              {classPermission?.delete === 1 && (
                <button
                  style={s.actionBtn}
                  onClick={() => destroy(id, delete_status === 1 ? 0 : 1, class_name)}
                  title={delete_status === 0 ? "Activate" : "Deactivate"}
                >
                  {delete_status === 0 ? (
                    <i className="fa-solid fa-xmark"></i>
                  ) : (
                    <i className="fa fa-trash"></i>
                  )}
                </button>
              )}
              <button
                style={{ ...s.actionBtn, color: "#3b82f6" }}
                onClick={() => {
                  setIsModalOpen(true);
                  setId({ class_id: id, branch_id: branch_id });
                }}
                title="Summative Assessment"
              >
                <i className="fa-solid fa-file"></i>
              </button>
            </div>
          ),
        };
      });
      setGetData(false);
      // keep the untransformed rows so the duplicate dialog can copy every
      // field (timing, instructor, duration…) not just the displayed ones
      setRawClasses(filtered);
      setData(arrayData, setShowResults(true));
    }
    const destroy = async (id, status, name) => {
      const data = {
        delete_status: status,
        title: name,
        deleted_by: branchid,
      };
      const result = window.confirm(
        `${status === 1
          ? "Are you sure you want to active this class?"
          : "Are you sure you want to inactive this class?"
        }`
      );
      if (result) {
        await class_destroy(data, id);
      }
      get_data();
    };
    get_data();
  }, [status, getData, showPast]);

  const columns = [
    { name: "No.", selector: "no", sortable: true, width: "70px" },
    { name: "Class Name", selector: "name", sortable: true },
    { name: "Year", selector: "year", sortable: true, width: "80px" },
    { name: "Branch", selector: "branch_name", sortable: true },
    { name: "Grade", selector: "grade_name", sortable: true, width: "100px" },
    { name: "Term", selector: "term_name", sortable: true, width: "80px" },
    { name: "Time", selector: "class_timing", sortable: true, width: "120px" },
    { name: "Status", selector: "status", sortable: true, width: "90px",
      cell: (row) => (
        <span style={{
          display: "inline-block",
          padding: "2px 10px",
          borderRadius: 12,
          fontSize: 11,
          fontWeight: 500,
          background: row.status === "Active" ? "#dcfce7" : "#fee2e2",
          color: row.status === "Active" ? "#166534" : "#991b1b",
        }}>
          {row.status}
        </span>
      ),
    },
    classPermission?.edit === 1 || classPermission?.delete === 1 || classPermission?.view === 1
      ? { name: "Action", selector: "action", sortable: false, width: "160px" }
      : "",
  ];

  const handleImpersonate = async (studentUserId) => {
    const res = await impersonate_student(studentUserId);
    if (res?.status && res?.data) {
      const encoded = btoa(JSON.stringify(res.data));
      window.open(`${STUDENT_PORTAL_URL}/impersonate?data=${encoded}`, '_blank');
    }
  };

  let childColumns = [
    { name: "#", selector: (_, index) => index + 1, sortable: false, width: "44px" },
    {
      name: "Name", sortable: true,
      cell: (row) => (
        <Link
          to={`/branch/enroll/member-edit/${row?.user_id}`}
          style={{ color: "#3b82f6", textDecoration: "none", fontSize: 12, fontWeight: 500 }}
          title="View Student"
        >
          {row.first_name} {row.last_name}
        </Link>
      ),
    },
    { name: "Phone", selector: (row) => row.mobile, sortable: true, width: "130px" },
    {
      name: "",
      width: "110px",
      cell: (row) => (
        <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
          <button
            style={{ ...s.childActionBtn, color: "#8b5cf6" }}
            onClick={() => handleImpersonate(row?.user_id)}
            title="Login as Student"
          >
            <i className="fa fa-right-to-bracket"></i>
          </button>
          {classPermission?.edit === 1 && (
            <Link to={`/branch/class-management/assigne-student-edit/${row?.id}/${row.class_id}`} style={s.childActionBtn} title="Edit Enrollment">
              <i className="fa fa-pencil"></i>
            </Link>
          )}
          <button style={{ ...s.childActionBtn, color: "#ef4444" }} onClick={() => destroy_student(row?.user_id)} title="Remove">
            <i className="fa fa-trash"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const destroy_student = async (id) => {
    const result = window.confirm("Are you sure you want to delete this student?");
    if (result) {
      await student_destroy(id);
      setGetData(true);
    }
  };

  const s = {
    page: { padding: "20px 24px" },
    header: {
      display: "flex", justifyContent: "space-between", alignItems: "center",
      marginBottom: 20,
    },
    titleArea: { display: "flex", alignItems: "center", gap: 16 },
    title: { fontSize: 18, fontWeight: 600, margin: 0, color: "#1a1a2e" },
    headerRight: { display: "flex", alignItems: "center", gap: 10 },
    statusSelect: {
      padding: "5px 10px", fontSize: 12, borderRadius: 6,
      border: "1px solid #ddd", background: "#fff", color: "#555",
      outline: "none", cursor: "pointer", minWidth: 110,
    },
    addBtn: {
      display: "inline-flex", alignItems: "center", gap: 6,
      padding: "7px 16px", borderRadius: 6, fontSize: 13, fontWeight: 500,
      background: "#3b82f6", color: "#fff", border: "none",
      textDecoration: "none", cursor: "pointer", whiteSpace: "nowrap",
    },
    dupBtn: {
      display: "inline-flex", alignItems: "center", gap: 6,
      padding: "7px 14px", borderRadius: 6, fontSize: 13, fontWeight: 500,
      background: "#fff", color: "#3b82f6", border: "1px solid #3b82f6",
      cursor: "pointer", whiteSpace: "nowrap",
    },
    actionBtn: {
      width: 28, height: 28, borderRadius: 6, border: "1px solid #e5e7eb",
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      background: "#fff", color: "#666", cursor: "pointer", fontSize: 12,
      padding: 0, textDecoration: "none",
    },
    childActionBtn: {
      width: 24, height: 24, borderRadius: 4, border: "1px solid #e5e7eb",
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      background: "#fff", color: "#888", cursor: "pointer", fontSize: 11,
      padding: 0, textDecoration: "none",
    },
  };

  return (
    <div className="right-nav" id="dash-event" style={s.page}>
      {showResults ? (
        <>
          {/* Header */}
          <div style={s.header}>
            <div style={s.titleArea}>
              <h4 style={s.title}>
                Classes
                <span style={{ fontSize: 11, fontWeight: 500, color: "#64748b", marginLeft: 8 }}>
                  ({level === "high" ? "High school" : "Primary"})
                </span>
              </h4>
            </div>
            <div style={s.headerRight}>
              <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "#475569", cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={showPast}
                  onChange={(e) => setShowPast(e.target.checked)}
                />
                Show past years
              </label>
              <select
                style={s.statusSelect}
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">All Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
              {classPermission?.add === 1 && (
                <button
                  type="button"
                  style={s.dupBtn}
                  onClick={() => setShowDuplicate(true)}
                  title="Copy a term's classes into another term"
                >
                  <i className="fa fa-copy" style={{ fontSize: 11 }}></i> Duplicate
                </button>
              )}
              {classPermission?.add === 1 && (
                <Link style={s.addBtn} to="/branch/class-management/add">
                  <i className="fa fa-plus" style={{ fontSize: 11 }}></i> Add Class
                </Link>
              )}
            </div>
          </div>

          <CustomTableWithChild
            columns={columns}
            data={data}
            childColumns={childColumns}
            type="class"
          />
        </>
      ) : (
        <DataLoader />
      )}
      <ActiveEvaluation
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        id={id}
      />
      {showDuplicate && (
        <DuplicateClasses
          classes={rawClasses}
          branchId={branchid}
          onClose={() => setShowDuplicate(false)}
          onDone={() => { setShowDuplicate(false); setGetData(true); }}
        />
      )}
    </div>
  );
};
export default AllClasses;
